// Modale de réservation multi-restaurants (#modal-booking) :
// bascule entre le sélecteur de restaurant et le widget ZenChef, et charge l'iframe à la demande.
// L'ouverture de la modale est gérée par Alpha (modal-linker + bsModal) via href="#modal-booking".

const MODAL_ID = 'modal-booking'
const ZENCHEF_BASE = 'https://bookings.zenchef.com/results'

function initBookingModal() {
  const modal = document.getElementById(MODAL_ID)

  if (!modal) {
    return
  }

  const frame = modal.querySelector('#booking-modal-frame')
  const chooser = modal.querySelector('.booking-modal__chooser')
  const widget = modal.querySelector('.booking-modal__widget')

  if (!frame || !chooser || !widget) {
    return
  }

  const showWidget = () => {
    chooser.hidden = true
    widget.hidden = false
  }

  const showChooser = () => {
    widget.hidden = true
    chooser.hidden = false
  }

  const choices = chooser.querySelectorAll('[data-restaurant-id]')

  // Les CTA des cartes restaurant ciblent leur propre adresse (data-booking-restaurant) ;
  // les autres CTA « Réserver » du site ouvrent la modale sans cible et laissent les 3 visibles.
  const filterChoices = (restaurantId) => {
    // Un restaurant peut être absent du sélecteur (ni téléphone ni réservation en ligne) :
    // dans ce cas on ne filtre pas, sinon la modale s'ouvrirait vide.
    const isKnown = restaurantId &&
      [...choices].some((choice) => choice.dataset.restaurantId === restaurantId)

    choices.forEach((choice) => {
      choice.hidden = isKnown && choice.dataset.restaurantId !== restaurantId
    })
  }

  modal.addEventListener('show.bs.modal', (event) => {
    filterChoices(event.relatedTarget && event.relatedTarget.dataset.bookingRestaurant)
  })

  modal.addEventListener('click', (event) => {
    const bookTrigger = event.target.closest('[data-zenchef-id]')

    if (bookTrigger) {
      const id = bookTrigger.dataset.zenchefId
      frame.src = `${ZENCHEF_BASE}?rid=${encodeURIComponent(id)}&fullscreen=1`
      showWidget()
      return
    }

    if (event.target.closest('[data-booking-back]')) {
      showChooser()
    }
  })

  // À la fermeture, on revient au sélecteur complet et on décharge l'iframe
  // (stoppe le chargement ZenChef).
  modal.addEventListener('hidden.bs.modal', () => {
    frame.removeAttribute('src')
    filterChoices(null)
    showChooser()
  })
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBookingModal)
} else {
  initBookingModal()
}
